import React, { useState, useCallback } from 'react';
import NumeriTable from '../components/NumeriTable';
export default function NumeriPage() {
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = useCallback(() => setRefreshKey(k => k + 1), []);
  return (
    <div>
      <h1 style={{ fontSize: 20, marginBottom: 16 }}>Numeri</h1>
      <NumeriTable refreshKey={refreshKey} onJobStarted={() => {}} onDeleted={refresh} onVerifiedSingle={refresh} disabled={false} />
    </div>
  );
}
